import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MdDialogModule, MdButtonModule, MdIconModule, MdToolbarModule } from '@angular/material'
import { TranslateModule } from '@ngx-translate/core'

import { ImageCropperModule } from 'ng2-img-cropper'

import { SharedModule } from '../shared/shared.module'
import { DialogService } from './shared/dialog.service'
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component'
import { CropDialogComponent } from './crop-dialog/crop-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component'

import { ToolbarModule } from '../toolbar/toolbar.module';
import { ShareDialogComponent } from './share-dialog/share-dialog.component'
import { SocialShareModule } from '../social-share/social-share.module'

import { Angulartics2Module } from 'angulartics2'

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MdDialogModule,
    MdButtonModule,
    MdIconModule,
    MdToolbarModule,
    // SharedModule,
    // ToolbarModule,
    ImageCropperModule,
    SocialShareModule,
    Angulartics2Module.forChild()
  ],
  exports: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    CropDialogComponent
  ],
  declarations: [
    ConfirmDialogComponent,
    CropDialogComponent,
    AlertDialogComponent,
    ShareDialogComponent
  ],
  providers: [
    DialogService
  ],
  entryComponents: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    CropDialogComponent,
    ShareDialogComponent
  ]
})
export class DialogModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/dialog.module.ts